import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failurelistCourseCategory,
    successlistCourseCategory,
} from "./ListCourseCategorySlice";
import { failureaddCourseCategory, successaddCourseCategory } from "./AddCourseCategorySlice";
import { ICourseCategory } from "../../../Pages/CourseCategory/ICourseCategory";

const ListCourseCategoryApi = (action: PayloadAction<any>) => {
    return api.get("/api/course_category", {
        params: action.payload,
    });
};

export function* ListCourseCategoryCall(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse = yield call(ListCourseCategoryApi, action);
        yield put(successlistCourseCategory(response.data));
    } catch (error) {
        yield put(failurelistCourseCategory(error));
    }
}

// Consolidated add / edit / delete — id present = edit, is_delete: true = delete
const AddCourseCategoryApi = (action: PayloadAction<ICourseCategory>) => {
    return api.post("/api/course_category/create_edit", action.payload);
};

export function* AddCourseCategoryCall(action: PayloadAction<ICourseCategory>) {
    try {
        const response: AxiosResponse = yield call(AddCourseCategoryApi, action);
        yield put(successaddCourseCategory(response.data));
    } catch (error) {
        yield put(failureaddCourseCategory(error));
    }
}
